<script lang="ts">
	import { reveal } from '$lib/actions/reveal';
	import SectionHeading from '$lib/components/ui/SectionHeading.svelte';

	const points = [
		{
			title: 'One platform, any hardware',
			description:
				'Admiral runs identically on powerful x86 servers and low-cost ARM devices. One OCI image, one workflow — from the factory floor to the billboard on the side of the road. No per-architecture toolchains.'
		},
		{
			title: 'Deploy in seconds, not weeks',
			description:
				'Devices come online within seconds of being powered on. Push OTA updates, new containers, or configuration changes to your entire fleet from a single command — even over unreliable cellular connections.'
		},
		{
			title: 'Built for teams of one',
			description:
				'Everything you need to run a production edge fleet ships in the box. No bolted-together toolchain, no dedicated embedded team required. One engineer can manage millions of devices with Admiral.'
		}
	];
</script>

<section
	class="mx-auto mt-20 max-w-[1216px] px-4 sm:mt-32 lg:px-0"
	aria-labelledby="what-is-admiral"
>
	<div class="reveal" use:reveal>
		<SectionHeading
			eyebrow="What is Admiral?"
			title="The fastest way to run a fleet of Linux devices"
			description="Admiral bundles an immutable Linux distribution, the fleet management dashboard, OTA updates, and the security layer as a single product; so you can focus on your workload instead of your infrastructure."
		/>
	</div>

	<!-- <div class="mt-16 grid grid-cols-1 gap-8 md:grid-cols-3" use:reveal>
		{#each points as point}
			<article class="reveal">
				<h3 class="mb-3 font-display text-lg font-medium text-white">{point.title}</h3>
				<p class="font-display text-base leading-relaxed text-white/60">{point.description}</p>
			</article>
		{/each}
	</div> -->
</section>
